// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"7ec43989","182":"399aeb66","196":"1e1e75ac","268":"4a691595","418":"ed0c408f","453":"7e0b3d37","511":"1c32bb89","540":"9b6ff718","623":"5d86d702","639":"723d5626","848":"72e3b1e1","872":"de2a3140","944":"70998338","958":"23e3ecb8","964":"ed4b1f4b"}[chunkId] + ".chunk.js";
};